import { getFullName } from "shared/utils/get-full-name";
import {
  CancelManuallyAddedIncomeActivity,
  IncomeAddedManuallyActivity
} from "../types";

export const ManuallyAddedIncomeEvent = ({
  activityItem
}: {
  activityItem: IncomeAddedManuallyActivity | CancelManuallyAddedIncomeActivity;
}) => {
  const applicantName = getFullName({
    firstName: activityItem.details.contact.first_name,
    middleName: activityItem.details.contact.middle_name,
    lastName: activityItem.details.contact.last_name,
    short: true
  });

  return (
    <div className="space-y-2 -mb-2">
      <p className="text-content-1000">
        {activityItem.activity_type === "income_added_manually" ? (
          <>
            <span className="font-bold">New income source</span> was added
          </>
        ) : (
          <span className="font-bold">Income verification was canceled</span>
        )}
        {" by "}
        {activityItem.author?.name}
      </p>
      <p className="text-content-400 text-sm">
        for {applicantName}
        {" — Income source: "}
        {activityItem.details.income.name}
      </p>
    </div>
  );
};
